import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SocialLinks from "@/components/SocialLinks";

interface ContentPageFooterProps {
  /** The current page path to exclude from cross-links */
  currentPath: string;
}

const allLinks = [
  { path: "/about", key: "crossLinks.aboutAyeris" },
  { path: "/faq", key: "crossLinks.faq" },
  { path: "/guides", key: "crossLinks.guides" },
  { path: "/blog", key: "crossLinks.blog" },
  { path: "/privacy-policy", key: "crossLinks.privacy" },
  { path: "/terms-of-service", key: "crossLinks.terms" },
];

const ContentPageFooter = ({ currentPath }: ContentPageFooterProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer className="mt-10 space-y-6">
      <button
        onClick={() => navigate("/landing")}
        className="w-full py-2.5 rounded-xl bg-primary/10 text-primary text-sm font-medium hover:bg-primary/20 transition-colors"
      >
        ← {t("crossLinks.backToAyeris", "Back to Ayeris")}
      </button>

      <nav>
        <h2 className="text-sm font-display font-semibold text-foreground mb-3">
          {t("crossLinks.explore")}
        </h2>
        <ul className="space-y-2 text-sm">
          {allLinks
            .filter((l) => l.path !== currentPath)
            .map((l) => (
              <li key={l.path}>
                <a href={l.path} className="text-primary hover:underline">
                  {t(l.key)}
                </a>
              </li>
            ))}
        </ul>
      </nav>

      <SocialLinks className="mt-2" />
      <p className="text-[10px] text-muted-foreground/60 text-center pb-4">
        © 2026 Ayeris.tv — All rights reserved.
      </p>
    </footer>
  );
};

export default ContentPageFooter;
